import { TypeHelpers } from "@common/utils/type.helpers";
import { IBaseEntity, IBaseInterfaceData } from "./base";
import {
  BuildingMetadata,
  GisfoPort,
  IBuildingInfo,
  IFibPort,
  IFibSignal,
  IGisfoCreateNetFaultMaintenance,
  IGisfoResponceNetFaultMaintenance
} from "./gisfo";
import { ID } from "./id";
import { InterfaceName } from "./issueTypeInterface";
import { NetOwnerNamesValue } from "./oloConfig";
import { IIssue } from "./issue";
import { StatoContrattoValue } from "./portaleContrattiCommunication";
import { IAppointment } from "./appointment";
import { NetworkNodeDto, PopDto, SecondarySplitterDto } from "@common/dto/buildingSearchResponse.dto";
export interface IID_CONFERMA_APPUNTAMENTO extends IBaseInterfaceData {}

export type UnlockValidation = 'PENDING' | 'OK' | 'KO' | 'FAIL';
export type ProvisioningBlockReason = 'RETRY_EXHAUSTED' | 'UNLOCK_SUBMITTED';

export type UnlockTripleCheck = {
  code_match: boolean;
  ont_adopted_on_mosaic: boolean | null;
  cpe_logged_on_radius: boolean | null;
};

export interface IID_UNLOCK_CODE extends IBaseInterfaceData {
  orderId?: string;
  correlationId?: string;
  code?: string;
  validation: UnlockValidation;
  unlockSubmittedAt?: string;
  unlockExpiresAt?: string;
  unlockResultReceivedAt?: string;
  technicianId?: string;
  submittedIp?: string;
  tripleCheck?: UnlockTripleCheck;
  reconciliation?: string;
  reason?: string;
  alertId?: string;
  offlineUnlockFlag: boolean;
  unlockCodeId?: string;
  completionTransitionedAt?: string;
  unlockEnabled: boolean;
  provisioningBlocked: boolean;
  provisioningBlockReason?: ProvisioningBlockReason;
}

export const PHOTO_ESPLETATO_OK_CHECKLIST_GISFO_KEYS = ["PHOTO_ESPLETATO_OK_CHECKLIST_GISFO"] as const;
export type IEspletatoOkChecklistGISFOPhotos = {
  [key in (typeof PHOTO_ESPLETATO_OK_CHECKLIST_GISFO_KEYS)[number]]: string[];
};
export interface IID_ESPLETATO_OK_CHECKLIST_GISFO extends IBaseInterfaceData {
  causale: string;
  note: string;
  metadata: {
    fkEntity: string;
    checklist: GisfoChecklist;
    project_id: string;
  };
  photos: IEspletatoOkChecklistGISFOPhotos;
}

export type GisfoChecklist = {
  id: string;
  is_open: boolean;
  fk_incaricato: number;
  type: string;
  questions: GisfoChecklistQuestion[];
};

export type GisfoChecklistQuestion = {
  id: string;
  cl_domanda_id: string;
  text: string;
  is_answer_required?: boolean; // se la risposta è obbligatoria
  answer_text: string; //note
  answer_id: string; //risposta
  is_persisted: boolean;
  options?: { key: string; value: string; is_reason_required?: boolean }[];
};
export interface IID_CHECKLIST_GISFO extends IBaseInterfaceData {
  idOggetto: string;
  data: {
    fkEntity: string;
    project_id: string;
    checklists: GisfoChecklist[];
  };
}
export interface IID_RISORSA_LORA extends IBaseInterfaceData {
  idGateway: string;
  geometria: string;
  latitudine: string;
  longitudine: string;
  stato: string;
  note: string;
  indirizzo: string;
  nome: string;
  civico: string;
  esponente: string;
  codiceSito: string;
  codiceCollaudo: string;
  comune: string;
  lotto: string;
  metadata: {
    fkEntity: string;
    project_id: string;
    project_name: string;
    byGisfo: boolean;
  };
  progettoBusiness?: string; // rimuovere '?' a sviluppo finito
}

export enum TipologiaEPTicket {
  "Richiesta" = "Richiesta",
  "Problema" = "Problema"
}

export enum OggettoRichiesta {
  "Installazione_Software" = "Installazione Software", //2 basso
  "Primo_accesso_file_server" = "Primo accesso File Server", //3 medio
  "Installazione_VPN" = "Installazione VPN", //3 medio
  "Altro" = "Altro"
}

export enum OggettoProblema {
  "Computer_bloccato" = "Il Computer è bloccato o non si accende", //5 massimo
  "MS_Teams" = "MS Teams", //2 basso
  "Accesso_File_Server" = "Accesso File Server", //4 alto
  "Macchine_Virtuali" = "Macchine Virtuali", //3 medio
  "VPN" = "VPN", //4 alto
  "Software_di_lavoro" = "Software con cui sto lavorando", //4 alto
  "Monitor" = "Monitor", //3 medio
  "Microfono" = "Microfono", //3 medio
  "Hardware" = "Hardware", //2 basso
  "Altro" = "Altro"
}

export interface IID_EP_TICKET extends IBaseInterfaceData {
  tipologia: TipologiaEPTicket;
  oggetto: OggettoRichiesta | OggettoProblema;
  note: string;
}

export interface IID_OL_CLIENTE extends IBaseInterfaceData {
  /* name: string;
  surname: string;
  phoneNumber: string;
  mobileNumber?: string;
  email?: string; */
  nome: string;
  cognome: string;
  recapitoTelefonico1: string;
  recapitoTelefonico2: string;
  email: string;
  codiceFiscale: string;
  informazioniLogisticaApparati: string;
}

export interface IID_OL_CONTRATTO extends IBaseInterfaceData {
  //indirizzo: string;
  //civico: string;
  //particellaToponomastica: string;
  //codOrdine: string;
  //olo: string;
  //tipoServizio: string;
  //dataAttesaConsegna: string;
  //dataPrevistaAttivazione: string; //DATE
  //identificativoPrenotazione: string;
  /* orarioAppuntamento: string; */ //DATE TIME
  codiceProgettoSpeciale: string;
  promozione: string;
  clusterPromozione: string;
  note: string;
}

export interface IID_GENERIC_SUSPENSION extends IBaseInterfaceData {
  causa: string;
  note?: string;
}

export interface IID_GENERIC_KO extends IID_GENERIC_SUSPENSION {}

export interface IID_APPARATO_SPLITTER extends IBaseInterfaceData {
  tipologiaApparato?: string;
  azioneApparato?: string;
  idApparato?: string;
  passwordApparato?: string;
  descrizioneAzioneApparato?: string;
  pfsName?: string;
  pfsSplitterName?: string;
  latitudinePfs?: string;
  longitudinePfs?: string;
  indirizzoPfs?: string;
  fibraDropPfs?: string;
  esitoConsegnaApparato?: string;
  codiceMotivazioneConsegna?: string;
  motivazioneConsegna?: string;
}

export interface IID_GENERIC_OK extends IID_GENERIC_SUSPENSION {
  dettagliCausa?: string;
}

export interface IID_PRATICA_IRU_CUSTOMER extends IBaseInterfaceData {
  cedente?: string;
  richiedente?: string;
  riferimentoPraticaRichiedente?: string;
  nomePratica?: string;
  customer?: string;
  acronimoCustomer?: string;
  numFibre?: string;
  dataRicezioneRichiesta?: string;
  note?: string;
  documentoDiRichiesta?: string;
}

export interface IID_PRATICA_IRU_PROVIDER extends IBaseInterfaceData {
  cedente?: string;
  richiedente?: string;
  riferimentoPraticaGestore?: string;
  nomePratica?: string;
  numFibre?: string;
  dataRicezioneRichiesta?: string;
  note?: string;
  documentoDiRichiesta?: string;
}

export interface IID_FEASABILITY_CONNECTION_REQUEST extends IBaseInterfaceData {
  requestIdentifier?: string;
  requestDate?: string;
  dueDate?: string;
  networkOperator?: string;
  requester?: string;
  client?: string;
  connectionType?: string;
  fiberCount?: number;
  doubleRoute?: boolean;
  doubleAdduction?: boolean;
  doubleAccessPoint?: boolean;
  bandwidthProfile?: string;
  notes?: string;
  dedicatedBuildingFibers?: boolean;
  closeCircuit?: boolean;
  isConfirmed?: boolean;
}

export type IIDRequestIdentifierNodeType = 'building' | 'pop' | 'splice';

export type IIDRequestIdentifierNode = {
  type: IIDRequestIdentifierNodeType;
  id: string;
};

export type IIDRequestIdentifierPop = {
  id: string,
  nodeType?: "pop";
  gisfoNodeId?: string;
  popName?: string;
  masterPop?: string;
  municipalityName?: string;
  municipalityId?: string;
  latitude?: number;
  longitude?: number;
  radius?: number;
  distance?: number;
  distanceFromBuilding1?: number;
  distanceFromCoordinate?: number;
  buildingProximity?: boolean;
  building1ConnectionPop?: boolean;
  secondRoute?: boolean;
  popListCount?: number;
  bandwidthProfile?: string;
  darkFiberBuildingId?: string;
  geometry?: string;
  pops?: PopDto[];
};

export type IIDRequestIdentifierSplice = {
  id: string,
  nodeType?: "splice";
  gisfoSpliceId?: string;
  spliceName?: string;
  municipalityName?: string;
  municipalityId?: string;
  latitude?: number;
  longitude?: number;
  radius?: number;
  distance?: number;
  geometry?: string;
  darkFiberBuildingId?: string
};

export type IIDRequestIdentifierBuilding = {
  id: string,
  nodeType?: "building";
  gisfoNodeId?: string;
  idBuilding?: string;
  addressInDb?: string;
  municipalityName?: string;
  municipalityId?: string;
  address?: string;
  streetNumber?: string;
  exponent?: string;
  staircaseReference?: string;
  parcel?: string;
  latitude?: number;
  longitude?: number;
  radius?: number;
  linkPopIds?: string[];
  linkPopNames?: string[];
  defaultPop?: string;
  defaultPopName?: string;
  secondarySplitterNode?: SecondarySplitterDto;
  darkFiberNode?: NetworkNodeDto;
  geometry?: string;
  pops?: PopDto[];
};

export interface IID_FEASABILITY_REQUEST_IDENTIFIER extends IBaseInterfaceData {
  nodes?: IIDRequestIdentifierNode[];
  buildings?: IIDRequestIdentifierBuilding[];
  pops?: IIDRequestIdentifierPop[];
  splices?: IIDRequestIdentifierSplice[];
  sent?: boolean;
  cardinality?: number;
}

export type IIDFeasabilityRequestIdentifierSection = {
  nodes?: IIDRequestIdentifierNode[];
  buildings?: IIDRequestIdentifierBuilding[];
  pops?: IIDRequestIdentifierPop[];
  splices?: IIDRequestIdentifierSplice[];
  cardinality?: number;
};

export type IIDFeasabilityInvolvedPop = {
  id?: string;
  name?: string;
  undName?: string;
};

export interface IID_FEASABILITY_RESPONSE extends IBaseInterfaceData {
  requestIdentifierSections?: IIDFeasabilityRequestIdentifierSection[];
  unimarketId?: string;
  gisfoFeasabilityState?: string;
  activationDays?: number;
  coverageCost?: number;
  coverageCostRevision?: number;
  involvedPops?: IIDFeasabilityInvolvedPop[];
  gisfoFeasabilityId?: string;
  notes?: string;
  errorMessage?: string;
  cardinality?: number;
}

export interface IID_FEASABILITY_ASSOCIATION extends IBaseInterfaceData {
  idBuilding?: string;
  gisfoBuildingId?: string;
  sfIssueIds?: string[];
  gisfoFeasabilityId?: string;
  gisfoFeasabilityName?: string;
  unimarketIds?: string[];
  customer?: string;
  connectionType?: string;
  creationDate?: string;
  requestDate?: string;
  feasabilityState?: string;
  noStudyAvailable: boolean;
}

export interface IID_OL_SOSPENSIONE extends IBaseInterfaceData {
  causale: CausaleSospensione;
  comingStateId: ID;
  canUnlock: CanUnlock;
  note: string;
  causa: string;
}

// I commenti indicano a quale causa appartiene una certa causale (vedi oggetti in fondo: causaOperatore, causaCliente e causaOlo)
export enum CausaleSospensione {
  "Ripianificazione appuntamento causa OLO" = "D11", // olo
  "ID Building esistente ma non corrispondente al cliente" = "B06",  // olo
  "Attesa permessi di transito o accesso da terze parti" = "C05",  // operatore
  "Attesa Permesso Amminstratore" = "C09",  // operatore
  "Blocco tecnico provvisorio" = "C10",  // operatore
  "Blocco generico" = "C11",  // operatore
  "Nuova GPON di Attestazione" = "C12",  // operatore
  "In attesa di realizzazione RFA" = "C13",  // operatore
  "Cliente irreperibile on-call" = "D02",  // cliente
  "Cliente rifiuta l'intervento on call" = "D03",  // cliente
  "Rifiuto cliente on-field" = "D04",  // cliente
  "Irreperibilità cliente on-field" = "D05",  // cliente
  "Cliente vuole essere ricontattato on-call per presa appuntamento" = "D06",  // cliente
  "Recapito cliente errato o inesistente" = "D07",  // olo
  "Cliente richiede nuovo appuntamento per completamento intervento" = "D08",  // cliente
  "Cliente in attesa di ulteriori chiarimenti commerciali" = "D09",  // cliente
  "In attesa lavori in sede cliente" = "D10",  // cliente
  "Accettazione proposta tecnica per prolungamento ottico su proprietà privata" = "D25",  // olo //serve per chiedere all'olo - forse non va gestita esattamente come una sospensione
  "Attesa accettazione proposta tecnica prolungamento ottico proprietà privata" = "D26",  // olo
  "Infrastruttura cliente non idonea o ostruita" = "D27"  // cliente
}

export enum CanUnlock {
  "olo" = "olo",
  "operatore" = "operatore"
}

export enum AppuntamentoState {
  "TO_BE_ACCEPTED" = "0",
  "ACCEPTED" = "1",
  "RESCHEDULED" = "2",
  "INVALID" = "3"
}

export enum OloAppuntamentoState {
  "PENDING" = "0",
  "SENT" = "1",
  "ERROR" = "2"
}

export enum OloRDACMotivazione {
  "Motivi tecnici" = "C08",
  "Motivi cliente" = "D13"
}

export enum CausaleRDAC {
  "Ripianificazione appuntamento causa UNF" = "R00",
  "Modifica/Comunicazione appuntamento ad OLO" = "R01",
  "Ripianificazione appuntamento causa Cliente" = "R02",
  "Accettazione appuntamento OLO" = "R03",
  "Rimodulazione per Sospensione provisioning causa Permessi" = "R04",
  "Completamento intervento c/o cliente il giorno lavorativo successivo causa cliente" = "D00"
}

export enum NomeServizio {
  "Ribaltamento impianto" = "0",
  "Estensione impianto cliente" = "1",
  "SLA Premium Assurance" = "2",
  "Residential Gateway" = "3"
}

export enum InformazioniServizio {
  "Fornire servizio" = "0",
  "Fornire servizio solo se richiesto dal cliente on field" = "1"
}

export enum EsitoConsegnaApparato {
  "non_consegnato" = "0",
  "consegnato" = "1",
  "consegnato_e_installato" = "2",
  "consegnato_non_installato" = "3",
  "installato" = "4",
  "non_installato" = "5"
}

export enum MotivazioneEsitoConsegnaApparato {
  "Rifiuto cliente on-field per consegna apparato" = "E00",
  "Apparato non presente in sede cliente" = "E01",
  "Configurazione parziale apparato" = "E02",
  "Cliente irreperibile on-field per ritiro apparato" = "E03",
  "Rifiuto cliente on-field per ritiro apparato" = "E04"
}

export enum MotivazioneEsitoServizio {
  "Servizio aggiuntivo non effettuabile/attivabile" = "E05",
  "Rifiuto cliente on-field per esecuzione servizio aggiuntivo" = "E06"
}

export enum AzioneApparato {
  "consegna" = "0",
  "consegna_e_installazione" = "1",
  "solo_installazione" = "2"
}

/** A `solo_installazione` apparato is already at the customer's: it never moves through the warehouse. */
export function isWarehouseApparato(apparato: { azioneApparato?: string | null }): boolean {
  return apparato?.azioneApparato !== AzioneApparato.solo_installazione;
}

/** Esiti that mean the device left the warehouse and reached the customer. */
export const DELIVERED_ESITI_APPARATO: ReadonlySet<EsitoConsegnaApparato> = new Set([
  EsitoConsegnaApparato.consegnato,
  EsitoConsegnaApparato.consegnato_e_installato,
  EsitoConsegnaApparato.consegnato_non_installato,
]);

/** Delivered by esito; a missing esito counts as NOT delivered (the device stays in stock). */
export function isApparatoDelivered(apparato: { esitoApparato?: EsitoConsegnaApparato | string | null }): boolean {
  return DELIVERED_ESITI_APPARATO.has(apparato?.esitoApparato as EsitoConsegnaApparato);
}

/** Serve per far corrispondere i valori delle Enum AzioneApparato e EsitoConsegnaApparato */
export const AzioneToEsitoApparato = {
  [AzioneApparato.consegna]: EsitoConsegnaApparato.consegnato,
  [AzioneApparato.consegna_e_installazione]: EsitoConsegnaApparato.consegnato_e_installato,
  [AzioneApparato.solo_installazione]: EsitoConsegnaApparato.installato
} as const;

export const CodiceProgettoSpeciale = {
  GPON_B: "GPON_B",
  GPON_R: "GPON_R",
  P2P_B: "P2P_B",
  P2P_R: "P2P_R"
};

export enum MotivazioneAcquisitoKo {
  "Data Attesa Consegna non conforme agli SLA" = "A09",
  "Data Consegna coincidente con un giorno festivo o con un sabato" = "A10",
  "Appuntamento precedente alla Data Attesa Consegna" = "A11",
  "Identificativo Building Errato" = "B00",
  "Building non RFC/RFA" = "B01",
  "Scala non RFC/RFA" = "B02",
  "Associazione ID Building - POP errata" = "B03",
  "Città/pop non vendibile per l'OLO" = "B04",
  "OLO non abilitato all'invio dell'ordine" = "B05"
}

export enum MotivazioneAccettatoKo {
  "Accettato KO" = "C14",
  "GPON vincolante non utilizzabile" = "C20",
  "KO per time out" = "D18",
  "Mancanza permessi" = "C25"
}

export enum MotivazioneEspletatoKo {
  "ID Building non è quello per cui è richiesto attivazione" = "B08",
  "Servizio aggiuntivo richiesto inesistente" = "B09",
  "Building non collegabile" = "C01",
  "Scala non collegabile" = "C02",
  "Borchia Ottica occupata da altro OLO" = "C03",
  "Sbraccio non effettuabile" = "C04",
  "Rifiuto permessi di transito o accesso da terze parti" = "C06",
  "Espletato KO" = "C15"
}

export enum MotivazioneEspletatoOk {
  "Espletato OK" = "C07",
  "Espletato OK con riutilizzo infrastruttura esistente" = "C23"
}

export enum MotivazioneCessatoKO {
  "ID Risorsa da cessare inesistente/errato" = "B07",
  "Annullamento su richiesta OLO" = "D01"
}

export const MotivazioneCessatoOK = {
  codiceMotivazione: "C00",
  motivazione: "L'ordine di cessazione è stato espletato correttamente"
};

export interface IID_OL_ANNULLAMENTO extends IBaseInterfaceData {
  motivazione: string;
}

export const PHOTO_ESPLETATO_OK_KEYS = ["PHOTO_ESPLETATO_OK"] as const;
export type IEspletatoOkPhotos = {
  [key in (typeof PHOTO_ESPLETATO_OK_KEYS)[number]]: string[];
};

export interface IID_OL_ESPLETATO_OK extends IBaseInterfaceData {
  motivazione: MotivazioneEspletatoOk;
  idRisorsa: string;
  idSplitterSecondario: string;
  posizioneSplitterSecondario: string;
  parametriOttici: string;
  note: string;
  photos?: IEspletatoOkPhotos;

  network: NetOwnerNamesValue;

  rif_idBuilding: string;
  rif_scalaPalazzina: string;
  rif_indirizzo: string;
  rif_numeroCivico: string;
  rif_esponente: string;
  rif_piano: string;
  rif_interno: string;
  rif_uiResidenziali: string;
  rif_uiBusiness: string;
  rif_uiTotali: string;

  roe_nome: string;
  roe_numIn: string;
  roe_portaIn: string;
  roe_density: string;

  ss_posizione: IPositionType;
  ss_nome: string;
  ss_progressivoSplitter?: IProgressiveSplitter;
  ss_portaMorsettiereOut: string;
  ss_numeroFibraOut: string;
  ss_nomeGiunto: string;
  ss_seriale: string;
  ss_livelloSplitteraggio: ISplittingLevel;
  ss_numeroFibraIn: string;
  ss_portaSplitterOut: string;
  ss_proprietario: string;

  initialState: EspletatoOKState;
  currentState: EspletatoOKState;

  alignmentNotes?: string;
  alignmentState?: AlignmentStateValues;

  metadata: any;
}

export interface IID_OL_ESPLETATO_OK_OF extends IBaseInterfaceData {
  lavorazioneEffettuata: string;
  consegnaEffettuata: string;
  flagPagamento: string;
  numeroOperatore: string;

  GPONPortaAttuale: string;
  GPONAttestazioneAttuale: string;
  resourceIDAmpliamentoRetePFP: string;
  resourceIDFibra: string;
  serialNumberSplitterPFP: string;
  commentiPreformattati: string;

  lungOtticaSplitterSecondario: string;
  lungOttica: string;
  misuraOttica: string;
  bretellaOttica: string;
  bobinaLancio: string;
  riutilizzoBorchia: string;

  opereCivili: string;
  lungOpereCivili: string;
  lungInfrastruttura: string;
  metriTotaliInfrastruttura: string;
  tipoProlungamento: string;
  metriProlungamento: string;

  serialeBorchia: string;
  serialNumberONT: string;
  serialNumberSIM: string;
  serialNumberVIK: string;
  serialNumberMiFi: string;
  serialNumberVFTV: string;
}

export const AlignmentState = Object.freeze({
  Todo: 0,
  Done: 1,
  Unnecessary: 9
});

export type AlignmentStateValues = TypeHelpers.ValueOf<typeof AlignmentState>;
export type AlignmentStateKeys = keyof typeof AlignmentState;

export const IPositionTypes = ["PFS", "ROE", "GIUNTO"] as const;
export type IPositionType = TypeHelpers.ElementType<typeof IPositionTypes>;

export const IProgressiveSplitters = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16"] as const;
export type IProgressiveSplitter = TypeHelpers.ElementType<typeof IProgressiveSplitters>;

export const ISplittingLevels = ["1-2", "1-4", "1-8", "1-16", "1-32", "2-8"] as const;
export type ISplittingLevel = TypeHelpers.ElementType<typeof ISplittingLevels>;

export interface EspletatoOKState {
  rif_idBuilding?: string;
  rif_scalaPalazzina?: string;
  rif_indirizzo?: string;
  rif_numeroCivico?: string;
  rif_esponente?: string;
  rif_piano?: string;
  rif_interno?: string;
  rif_uiResidenziali?: string;
  rif_uiBusiness?: string;
  rif_uiTotali?: string;
  roe_nome?: string;
  roe_numIn?: string;
  roe_portaIn?: string;
  roe_density: string;
  ss_progressivoSplitter?: string;
  ss_portaMorsettiereOut?: string;
  ss_numeroFibraOut?: string;
  ss_seriale?: string;
  ss_livelloSplitteraggio?: string;
  ss_numeroFibraIn?: string;
  ss_portaSplitterOut?: string;
  ss_proprietario?: string;

  //ss_posizione: string;
  //ss_nome: string;
  //ss_nomeGiunto: string;
}

export interface IID_OL_ACCETTATO_KO extends IBaseInterfaceData {
  motivazione: MotivazioneAccettatoKo;
  note: string;
}

export interface IID_OL_ESPLETATO_KO extends IBaseInterfaceData {
  motivazione: MotivazioneEspletatoKo;
}

export interface IID_OL_ACQUISITO_KO extends IBaseInterfaceData {
  motivazione: MotivazioneAcquisitoKo;
  note: string;
}

export enum Tipologia {
  "PC_FISSO" = "PC Fisso",
  "PC_PORTATILE" = "PC Portatile",
  "MONITOR" = "Monitor",
  "MOUSE" = "Mouse",
  "TASTIERA" = "Tastiera",
  "LICENZA_SOFTWARE" = "Licenza Software",
  "SMARTPHONE" = "Smartphone",
  "TABLET" = "Tablet",
  "POSTAZIONE" = "Postazione",
  "KIT_GPS" = "Kit GPS",
  "KIT_WALK-OUT" = "Kit WalkOut",
  "ALTRO" = "Altro"
}

export interface IID_OL_APPUNTAMENTO extends IBaseInterfaceData {
  date: string;
  time: string;
  stato: AppuntamentoState;
  oloState: OloAppuntamentoState;
  impresa: string;
  identificativoPrenotazione: string;
  causale: CausaleRDAC;
  rescheduledByOlo?: boolean;
  causaleOlo?: OloRDACMotivazione;
  noteOlo?: string;
  userId?: string;
  userName?: string;
  zona?: string;
  appointmentId?: string;
  appointment?: IAppointment;
}

export interface IID_GENERIC_APPOINTMENT extends IBaseInterfaceData {
  date: string;
  time: string;
  duration: number;
  impresa: string;
  userId: string;
  zona: string;
  appointmentId?: string;
}

export enum SettoreAsset {
  Sviluppo = "Sviluppo",
  Progettazione = "Progettazione",
  Amministrazione = "Amministrazione",
  Speciale = "Speciale"
}
export interface IID_EP_ASSET extends IBaseInterfaceData {
  tipologia: Tipologia;
  marca: string;
  modello: string;
  destinatario: string;
  info: string;
  settore: SettoreAsset;
}

export enum SupportGisfoApplication {
  APP = "APP",
  WEB = "WEB",
  OM = "OM"
}

export enum AppError {
  AREA_EXPIRED = "Area Scaduta",
  INSTALLATION = "Errore installazione",
  CLOUD = "Disallineamento Cloud",
  FIBER = "Errori Fibre",
  SYNC = "Errori Sincronizzazione",
  APERTURA = "CRASH all'apertura",
  NON_PRIORITY = "Elemento non di priorità",
  LOGIN = "Problema Login",
  PHOTO = "Errore Invio Foto",
  DUBLICATION = "Duplicazione infrastruttura",
  RESTORE = "Recupero dati",
  OTHER = "Altro"
}

export enum WebError {
  STE = "STE",
  CMT = "CMT",
  USER = "Utenze",
  FIBER_SINOTTICO = "Errori Fibre/Sinottico",
  PROJECTS = "Errori Progettuali",
  OTHER = "Altro"
}

export enum OMError {
  GESTIONE_UTENZE = "Gestione Utenze",
  BLOCCO_SOFTWARE = "Blocco Software",
  BUG = "Bug",
  RICHIESTA_BONIFICA = "Richiesta di bonifica",
  OTHER = "Altro"
}

export interface IID_EP_SUPPORT extends IBaseInterfaceData {
  application: SupportGisfoApplication;
  problem: AppError | WebError | OMError;
  details: string;
  notes: string;
}

export interface IID_GR_RESOURCES extends IBaseInterfaceData {
  gisfoId: string;
  type: string;
  name: string;
  order: number;
  geometry: any;
  description: { label: string; text: string }[];
}

export interface IID_GR_RESOURCES_MAP extends IBaseInterfaceData {
  gisfoId: string;
  geometry: any;
}

export const MAN_KEYS = ["PHOTO_OPEN_MANHOLE", "PHOTO_CLOSED_MANHOLE"] as const;
export type IManholeExcavationPhotos = {
  [key in (typeof MAN_KEYS)[number]]: string[];
};
export function photosIsManholeExcavationPhoto(photos: any, issueTypeName: string): photos is IManholeExcavationPhotos {
  return issueTypeName === "MAN";
}

export const TR_KEYS = ["PHOTO_WIDE_OPEN_TRENCH", "PHOTO_WIDE_CLOSED_TRENCH", "PHOTO_DETAIL_DUCTS_DEPTH_TRENCH"] as const;
export type ITrenchExcavationPhotos = {
  [key in (typeof TR_KEYS)[number]]: string[];
};
export function photosIsTrenchExcavationPhoto(photos: any, issueTypeName: string): photos is ITrenchExcavationPhotos {
  return issueTypeName === "TR";
}

export const CAB_KEYS = ["PHOTO_OPEN_CABINET"] as const;
export type ICabinetDeploymentPhotos = {
  [key in (typeof CAB_KEYS)[number]]: string[];
};
export function photosIsCabinetDeploymentPhoto(photos: any, issueTypeName: string): photos is ICabinetDeploymentPhotos {
  return issueTypeName === "CAB";
}

export const AER_KEYS = ["PHOTO_WIDE_ALL_POLES", "PHOTO_WITH_SLACK_CAB_COMPLETED_OR_NOT_COMPLETED"] as const;
export type IAerialWorksAndCablingPhotos = {
  [key in (typeof AER_KEYS)[number]]: string[];
};
export function photosIsAerialWorksAndCablingPhoto(photos: any, issueTypeName: string): photos is IAerialWorksAndCablingPhotos {
  return issueTypeName === "AER";
}

export const UCAB_KEYS = ["PHOTO_WITH_SLACK"] as const;
export type IUndergroundCablingPhotos = {
  [key in (typeof UCAB_KEYS)[number]]: string[];
};
export function photosIsUndergroundCablingPhoto(photos: any, issueTypeName: string): photos is IUndergroundCablingPhotos {
  return issueTypeName === "UCAB";
}

export const PHOTO_KEYS = [...MAN_KEYS, ...TR_KEYS, ...CAB_KEYS, ...AER_KEYS, ...UCAB_KEYS];
export type IGrTasksPhotos = {
  [key in (typeof PHOTO_KEYS)[number]]?: string[];
};

export interface IID_GR_TASKS extends IBaseInterfaceData {
  photos?: IGrTasksPhotos;
  totalLength?: string;
  rfidScan?: string;
  cablingCompleted?: boolean;
  issueId: string;
  projectId: string;
}

export interface IID_GISFO_WORKORDER extends IBaseInterfaceData {
  gisfoWorkorderId: string;
  name: string;
  status: string;
  gisfoProjectId: string;
  projectName?: string;
  issueId: string;
  projectId: string;
}

export interface IID_EP_RICHIESTA_PERMESSO extends IBaseInterfaceData {
  istanza: string;
  ente: string;
  tipologiaPermesso: string;
  strada: string;
}

export const WebErrorDetail = {
  STE: ["Estrazione", "Log di errori"],
  NT2: ["Caricamento", "Estrazione"],
  NT2STAR: ["Caricamento", "Estrazione"],
  CMT: ["Estrazione", "Importo P+"],
  USER: ["Estrazione", "DIsattivazione", "Aggiornamento anagrafica", "Estensione utenza", "Recupero Password"],
  FIBER_SINOTTICO: ["Errori progettuali nell'ottico", "Cavi con potenzialità inferiore"],
  GDL: ["Inserimento impresa si tratta", "Mancanza anagrafica", "Anomalie CronoProgramma"],
  SOL_30: ["Validazione record", "Validazione produzione"]
};

export const RiferimentiMetadataErrors = {
  not_present_buildings:
    "Attenzione: non è presente nessun building associato al codice Id Building (In nessun progetto GISFO), è possibile solo procedere in modalità manuale.",
  not_present_pte:
    "Attenzione: non è presente nessun Pte associato al codice Id Building (In nessun progetto GISFO), è possibile solo procedere in modalità manuale.",
  more_buildings: "Errore: è presente più di un building associato al codice Id Building."
} as const;

export type RiferimentiMetadataErrorType = keyof typeof RiferimentiMetadataErrors;

export interface IRiferimentiMetadata {
  error?: RiferimentiMetadataErrorType;
  buildings: IBuildingInfo[] | BuildingMetadata[];
}

export interface IContractOrder {
  id: number;
  contract_code: string;
  provider: number;
  id_risorsa_om: string;
  fk_building_units: number;
  fk_kv_contract_state: string;
  fk_kv_connection_type: number;
  contract_state: string;
  connection_type: string;
  provider_value: string;
  fib_ports_name: string;
  fib_ports_id: string;
  isSelected?: boolean;
  type?: 'master' | 'slave' | null;
}

export interface BuildingUnitsList {
  pk_building_units: number;
  fk_prj_nodes: number;
  unit_id: number;
  apt_floor: number;
  apt_number: string;
  customer: string;
  is_business: boolean;
  datamodifica: number;
  nomeoperatore: string;
  loop_number: number;
  tipo_ui: string;
  tipo_segnale: string;
  drawing: string;
  indirizzo: string;
  civico: string;
  esponente: string;
  id_building: string;
  contractOrderList: IContractOrder[];
}

export interface IRiferimentiUiMetadata extends BuildingUnitsList {
  isSelected: boolean;
}

/* export interface IRiferimentiUiMetadata extends IBuildingUnits {
  provider: string;
  pk_pcab_nodes: string;
  pcab_nodes_name: string;
  tipo_segnale: string;
  fk_pte: string;
  drawing: string;
  indirizzo: string;
  civico: string;
  esponente: string;
  id_building: string;
  isSelected: boolean;
  connection_type: string;
  contract_state: string;
  fib_ports_name: string;
  id_ports_associated: string;
  tipo_ui: string;
  provider_value: string;
} */

export interface IRiferimentiGisfoMetadata {
  owner: { id: number; value: string };
  connection_type: { id: number; value: string };
}

export interface META_INTERFACE extends IBaseEntity {
  name: string;
  formlyFields: any;
  options: IMetaInterfaceOptions;
  tableName: string;
  description: string;
  fieldsDescription: MetainterfaceFieldsDescription;
  creationMeta: ICreate_MetainterfaceDTO;
}

export interface ICreate_MetainterfaceDTO {
  name: string;
  description?: string;
  formlyFields: any[];
  fieldsDescription: MetainterfaceFieldsDescription;
  options?: IMetaInterfaceOptions;
}

export interface IMetaInterfaceOptions {
  formlyFormOptions: any;
  title: string;
  type: string;
  //TODO aggiungere altri options se serve
}

export type MetainterfaceFieldsDescription = {
  indexes: {
    columns: string[];
    unique?: boolean;
  }[];
  fields: {
    name: string;
    type: TMetainterfaceFieldsType;
  }[];
};

export type TMetainterfaceFieldsType =
  | "text"
  | "integer"
  | "decimal"
  | "boolean"
  | "date"
  | "time"
  | "timestamptz"
  | "_text"
  | "_integer"
  | "_decimal"
  | "_boolean"
  | "_date"
  | "_time"
  | "_timestamptz";

export interface IRisorsaMetadata {
  signal: IFibSignal;
  ptePorts: IFibPort[];
  ssPorts: IFibPort[];
  idPfsPort: string;
}

export enum GisfoIntegrationState {
  None,
  Partial,
  All
}

export interface IID_OL_RIFERIMENTI extends IBaseInterfaceData {
  idBuilding: string;
  scalaPalazzina: string;
  numeroTelefonicoPrincipaleLinea: string;
  recapitoTestLinea: string;
  identificativoPop: string;
  gponRichiesta: string;
  codiceOperatoreSecondario: string;
  particellaToponomastica: string;
  indirizzo: string;
  numeroCivico: string;
  esponente: string;
  pop: string;
  riferimentoUi: string;
  vendibilita: string;
  metadata?: IRiferimentiMetadata;
  byGisfo?: boolean;
  gisfoMetadata?: IRiferimentiGisfoMetadata;
  uiResidenziali: string;
  uiBusiness: string;
  statoVendibilita: string;
  codiceStatoVendibilita: string;
  comune: string;
  provincia: string;
  statoRetePni: string;
}

export interface IID_OL_RIFERIMENTI_UI extends IBaseInterfaceData {
  unitId: number;
  aptFloor: number;
  aptNumber: string;
  customer: string;
  contractCode: string;
  provider: string;
  contractState: string;
  isBusiness: boolean;
  connectionType: string;
  typeUi: string;
  typeSignal: string;
  idBuilding: string;
  ports: string;
  metadata?: IRiferimentiUiMetadata[];
}

export interface IID_OL_RISORSA extends IBaseInterfaceData {
  idRisorsa: string;
  namePte: string;
  portPte: string;
  portPfs: string;
  nameSplitterSecondario: string;
  portSplitterSecondario: string;
  nameSplitterPrimario: string;
  portSplitterPrimario: string;
  nodeSplitterSecondario: string;
  nodeSplitterPrimario: string;
  fiberNumberPte: string;
  fiberNumberPfs: string;
  fiberNumberSplitterPrimario: string;
  fiberNumberSplitterPrimarioIn: string;
  fiberNumberSplitterSecondario: string;
  ownershipSplitterPrimario: string;
  ownershipSplitterSecondario: string;
  seriale: string;
  ratioSplitterSecondario: string;
  namePfs: string;
  error: string;
  metadata?: IRisorsaMetadata;
  gisfoIntegrationState: GisfoIntegrationState;
  isSplitterSecondarioInsidePfs: boolean;
  positionSplitterSecondario: IPositionType;
  jointNameSplitterSecondario: string;
}

export interface IID_OL_RISORSA_PNI extends IBaseInterfaceData {
  idRisorsa: string;
  namePte: string;
  portPte: string;
  positionSplitterSecondario: IPositionType;
  nameSplitterSecondario: string;
  portSplitterSecondario: string;
  ownershipSplitterSecondario: string;
  nodeSplitterSecondario: string;
  portPfs: string;
  nodeSplitterPrimario: string;
  nameSplitterPrimario: string;
  ownershipSplitterPrimario: string;
  portSplitterPrimario: string;
  nodePop: string;
  portOdfPop: string;
  portPatchPanelPop: string;
  portGponPop: string;
  nameOltPop: string;
  portOltPop: string;
  portOdfOltPop: string;
  error: string;
  metadata?: IRisorsaMetadata;
  idServizio: string;
}

export const RisorseStatoRealizzativo = {
  REALIZZATO: "realizzato",
  NON_REALIZZATO: "non realizzato",
  GIA_ESISTENTE: "già esistente",
} as const;

export type RisorseStatoRealizzativoKey = keyof typeof RisorseStatoRealizzativo;
export type RisorseStatoRealizzativoValue = (typeof RisorseStatoRealizzativo)[RisorseStatoRealizzativoKey];

export type IRisorsePhotos = { [interfaceName: string]: string[] };

export interface IRisorsaSecondaria {
  idRisorsa: string;
  order: number;
}

export interface IID_RISORSE_CREATION extends IBaseInterfaceData {
  idRisorsa: string;
  misura: string;
  statoRealizzativo: RisorseStatoRealizzativoValue;
  nonConforme: boolean;
  note: string;
  idRisorseSecondarie: IRisorsaSecondaria[];
  photos?: IRisorsePhotos;
}

export interface IID_RISORSE_VERIFICA extends IBaseInterfaceData {
  idRisorsa: string;
  lunghezza: string;
  statoRealizzativo: RisorseStatoRealizzativoValue;
  nonConforme: boolean;
  note: string;
  idRisorseSecondarie: IRisorsaSecondaria[];
}

export interface IID_RISORSE_PERMESSO_PUBBLICO extends IBaseInterfaceData {
  idRisorsa: string;
  idRisorseSecondarie: IRisorsaSecondaria[];
  esito: string;
  accettato: boolean;
  prescrizioni: string;
  note: string;
}

export interface IID_RISORSE_IRU_ACQUISIZIONE extends IBaseInterfaceData {
  idRisorsa: string;
  idRisorseSecondarie: IRisorsaSecondaria[];
  misuraReale: string;
  esito: string;
  accettato: boolean;
  costiAdeguamento: string;
  note: string;
}

export interface IID_OL_CONDOMINIO extends IBaseInterfaceData {
  amministratore: string;
  indirizzoStudio: string;
  telefono: string;
  email: string;
}

export interface IID_OL_OLOREQUEST extends IBaseInterfaceData {
  codiceOperatore: string;
  network: string;
  codiceOrdineOlo: string;
  codiceOrdineOrig: string;
  codiceOrdine: string
  dataNotifica: string; //DATETIME
  idNotifica: string;
  nomeReferenteTecnicoOlo: string;
  cognomeReferenteTecnicoOlo: string;
  telefonoReferenteTecnicoOlo: string;
  emailReferenteTecnicoOlo: string;
  telefonoReferenteOloOnfiedNotech: string;
  tipoMasterSlave?: string;
  numTot?: number;
  idMaster?: string;
  idProgettoFattibilita?: string;
  idProgettoBusiness?: string;
}

export interface IID_OL_OLOREQUEST_OF extends IBaseInterfaceData {
  codiceOperatore: string;
  network: string;
  codiceOrdineOlo: string;
  dataNotifica: string; //DATETIME
  idNotifica: string;
  nomeReferenteTecnicoOlo: string;
  cognomeReferenteTecnicoOlo: string;
  telefonoReferenteTecnicoOlo: string;
  emailReferenteTecnicoOlo: string;
  telefonoReferenteOloOnfiedNotech: string;
  workorderId: string;
  tipologiaServizio: string;
  requestId: string;
  noteOperatore: string;
  noteOlo: string;
  accountTecnicoImpresa: string;
  dataEsecuzioneAttivita: string; //DATETIME
  tipoMasterSlave?: string;
  numTot?: number;
  idMaster?: string;
  idProgettoFattibilita?: string;
  idProgettoBusiness?: string;
  descrizioneAttivita?: string;
  tempoObiettivo?: string; //DATETIME
}

export interface IID_OL_ACTIVATION_REQUEST extends IBaseInterfaceData {
  CODICE_OPERATORE: string;
  NETWORK: string;
  CODICE_ORDINE_OLO: string;
  CODICE_ORDINE_ORIG: string;
  CODICE_ORDINE: string;
  DATA_NOTIFICA: Date; //type xs:dateTime YYYY-MM-ddThh:mm:ssTZD
  ID_NOTIFICA: string;
  NOME_REFERENTE_TECNICO_OLO: string;
  COGNOME_REFERENTE_TECNICO_OLO: string;
  TELEFONO_REFERENTE_TECNICO_OLO: string;
  EMAIL_REFERENTE_TECNICO_OLO: string;
  TELEFONO_REFERENTE_OLO_ONFIELD_NOTECH?: string;

  NOME_CLIENTE?: string;
  COGNOME_CLIENTE: string;
  RECAPITO_TELEFONICO_CLIENTE_1: string;
  RECAPITO_TELEFONICO_CLIENTE_2?: string;
  INFORMAZIONI_LOGISTICA_APPARATI?: string;

  ID_BUILDING: string;
  SCALA_PALAZZINA?: string;
  NUMERO_TELEFONICO_PRINCIPALE_LINEA?: string;
  RECAPITO_TEST_LINEA?: string;
  IDENTIFICATIVO_DEL_POP: string;
  GPON_RICHIESTA?: string;
  CODICE_OPERATORE_SECONDARIO?: string;

  DATA_PREVISTA_ATTIVAZIONE: Date; //type xs:date YYYY-MM-dd
  IDENTIFICATIVO_PRENOTAZIONE?: string;
  ORARIO_APPUNTAMENTO?: string; //type xs:time hh:mm:ss
  PROMOZIONE?: string;
  CLUSTER_PROMOZIONE?: string;
  NOTE?: string;
  // CODICE_PROGETTO_SPECIALE?: string;
  SERVIZIO_AGGIUNTIVO?: IObjectServizioAggiuntivo;
  APPARATO?: IObjectApparato;
  id_risorsa?: string;
}
export interface IObjectServizioAggiuntivo {
  item: IServizioAggiuntivo[];
}
export interface IServizioAggiuntivo {
  NOME_SERVIZIO: string;
  INFORMAZIONI_SERVIZIO: InformazioniServizio;
}
export interface IObjectApparato {
  item: IApparato[];
}
export interface IApparato {
  TIPOLOGIA_APPARATO: string;
  PASSWORD_APPARATO?: string;
  AZIONE_APPARATO: AzioneApparato;
  CAUSALE?: string;
}

export interface IID_OL_DEACTIVATION extends IBaseInterfaceData {
  network: string;
  codiceOperatore: string;
  codiceOrdineOlo: string;
  dataNotifica: string;
  idNotifica: string;
  idRisorsa: string;
  nomeCliente: string;
  cognomeCliente: string;
  recapitoTelefonicoCliente1: string;
  recapitoTelefonicoCliente2: string;
  note: string;
}

export interface IDeactivationPhysic {
  roeId: string;
  roeName: string;
  ports: GisfoPort[];
  dismissions: IDeactivationState[];
}

export interface IDeactivationState {
  dismissedAt: string;
  dismissedBy: string;
  pk_fib_ports: string;
}

export interface IID_OLO_DEACTIVATION_PHYSIC extends IBaseInterfaceData {
  deactivationPhysic: IDeactivationPhysic;
}

export interface IID_OLO_DEACTIVATION_VALIDATION extends IBaseInterfaceData {
  gisfoResponseData: any;
}

export enum EsitoServizio {
  "servizio_effettuato/attivato" = "0",
  "servizio_non_effettuato/attivato" = "1"
}

export interface IID_OL_SERVIZIO_AGGIUNTIVO extends IBaseInterfaceData {
  esitoServizio: EsitoServizio;
  codiceMotivazione?: MotivazioneEsitoServizio;
  anagraficaServizioAggId: ID;
  informazioni: string;
}

export interface IID_OL_APPARATO extends IBaseInterfaceData {
  tipologiaApparato: string;
  passwordApparato: string;
  azioneApparato: AzioneApparato;
  //causale: string;
  esitoApparato: EsitoConsegnaApparato;
  codiceMotivazione: MotivazioneEsitoConsegnaApparato;
  idApparato: string;
  provisioningStatus?: 'PENDING' | 'OK' | 'KO' | 'SOSTITUITO';
  provisioningErrorCode?: string;
  provisioningErrorMessage?: string;
  oltPort?: string;
  frozen?: boolean;
  frozenExpiresAt?: string;
  category?: string;
}

export enum EsitoRitiroApparato {
  YES,
  NO
}
export interface IID_OL_CHECKLIST extends IBaseInterfaceData {
  label: string;
  isChecked: boolean;
}
export interface IID_EP_RISPOSTA extends IBaseInterfaceData {
  protocol: string;
  oggetto: string;
  date: Date;
}

export interface IID_OL_SOLLECITO extends IBaseInterfaceData {
  codiceOrdineOlo: string;
  issueTypeId: string;
  initialIssueDetails: string;
}

export interface IID_OL_RISPOSTA_SOLLECITO extends IBaseInterfaceData {
  note: string;
  oloStatus: OloStatusSollecitoValue;
  dataSblocco: string;
}

export interface IID_OL_SUPPORTO extends IBaseInterfaceData {
  idRisorsa: string;
}

export interface IID_SLAEDITOR extends IBaseInterfaceData {
  contract: string;
  value: number;
  customer: string;
}

export interface IID_OL_RISOLUZIONE extends IBaseInterfaceData {
  classification: string;
  esito: boolean;
  activity: string;
}

export enum OloStatus {
  "Acquisito" = "0",
  "Acquisito_KO" = "1",
  "Accettato" = "2",
  "Accettato_KO" = "3",
  "Espletato" = "4",
  "Espletato_KO" = "5",
  "Richiesta_Annullamento" = "6",
  "Annullato" = "7",
  "Sospeso" = "8",
  "Cessato" = "9",
  "Cessato_KO" = "10",
  "Espletato_Migrazione" = "11"
}

export const oloStatus = {
  ACQUISITO: "Acquisito",
  ACQUISITO_KO: "Acquisito_KO",
  ACCETTATO: "Accettato",
  ACCETTATO_KO: "Accettato_KO",
  ESPLETATO: "Espletato",
  ESPLETATO_KO: "Espletato_KO",
  RICHIESTA_ANNULLAMENTO: "Richiesta_Annullamento",
  ANNULLATO: "Annullato",
  SOSPESO: "Sospeso",
  CESSATO: "Cessato",
  CESSATO_KO: "Cessato_KO",
  ESPLETATO_MIGRAZIONE: "Espletato_Migrazione"
} as const;
export type OloStatusKey = keyof typeof oloStatus;
export type OloStatusValue = (typeof oloStatus)[OloStatusKey];
export const oloStatusArrayValue: readonly OloStatusValue[] = Object.values(oloStatus);

export const OloStatusSollecito = {
  Acquisito: "ACQISITO",
  Acquisito_KO: "ACQISITO KO",
  Accettato: "ACCETTATO",
  Accettato_KO: "ACCETTATO KO",
  Espletato: "ESPLETATO",
  Espletato_KO: "ESPLETATO KO",
  Richiesta_Annullamento: "RICHIESTA ANNULLAMENTO",
  Annullato: "ANNULATO",
  Sospeso: "SOSPESO"
} as const;

export type OloStatusSollecitoKey = keyof typeof OloStatusSollecito;
export type OloStatusSollecitoValue = (typeof OloStatusSollecito)[OloStatusSollecitoKey];

export const OloStatusSollecitoEntries = Object.entries(OloStatusSollecito) as [OloStatusSollecitoKey, OloStatusSollecitoValue][];

export enum OloCommunicationStatus {
  "PENDING" = "0",
  "SENT" = "1",
  "ERROR" = "2",
  "RECEIVED" = "3"
}

export interface IID_OL_COMMUNICATION extends IBaseInterfaceData {
  status: OloCommunicationStatus;
  oloStatus: OloStatus;
  errorCode: string; //causale
  error: string; //motivazione,
  suspended: boolean;
  lastCommunicationDate?: string;
}

export interface IID_MAIL_GTW_SOURCE extends IBaseInterfaceData {
  mittente: string;
  destinatari: string[];
  destinatari_in_copia: string[];
  oggetto: string;
  corpo_html: string;
  data_ora: string;
  messageId: string;
}

export enum AssuranceTicketType {
  "GUASTO" = "GUASTO",
  "DEGRADO" = "DEGRADO"
}

export interface IID_ASSURANCE_TICKET extends IBaseInterfaceData {
  externalId: string;
  type: AssuranceTicketType;
  pop: string;
  pfs_pfp: string;
  pte_pta: string;
  description: string;
  _metadata: { guastoManualeCreated?: boolean; guastoGISFOCreated?: boolean };
}

export const totalEnumDecode = {
  ...OloRDACMotivazione,
  ...CausaleRDAC,
  ...MotivazioneAcquisitoKo,
  ...MotivazioneAccettatoKo,
  ...MotivazioneEspletatoKo,
  ...MotivazioneEspletatoOk,
  ...CausaleSospensione,
  onlyNumericDecode: {
    [InterfaceName.SERVIZIO_AGGIUNTIVO]: { nome: { ...NomeServizio }, esitoServizio: { ...EsitoServizio } },
    [InterfaceName.APPARATO]: { esitoApparato: { ...EsitoConsegnaApparato }, azioneApparato: { ...AzioneApparato } }
  }
};

export interface IID_NETWORK_ITEMS extends IBaseInterfaceData {
  name: string;
  order: number;
  types: string[];
  resourceIds: string[];
  resourceItemIds: string[];
  notes: { [type: string]: string };
}

export interface IID_NETWORK_ITEMS_SEND_EVIDENCE {
  issueId: string;
  order: number;
  resourceId: string;
  evidenceType: string;
}

export interface IID_NETWORK_ITEMS_SEND_TEST {
  issueId: string;
  order: number;
  resourceId: string;
  testType: string;
  testResult: string;
  measure: number;
}

export interface IID_NETWORK_ITEMS_SEND_INTERVENTION {
  issueId: string;
  order: number;
  resourceBrokenId: string;
  resourceFreeGisfoId: string;
  resourceFreeGisfoName: string;
  interventionType: string;
  interventionResolutive: boolean;
}

export interface IID_NETWORK_ITEMS_REMOVE_EVIDENCE {
  resourceItemId: string;
}

export interface IID_NETWORK_ITEMS_REMOVE_TEST {
  resourceItemId: string;
}

export interface IID_NETWORK_ITEMS_REMOVE_INTERVENTION {
  resourceItemId: string;
}

export interface IID_NETWORK_ITEMS_RESPONSE_ACTION {
  status: "error" | "success";
  message: string;
}

export interface IID_FAULT_MANAGEMENT extends IBaseInterfaceData {
  activityTypeId?: ID;
  workorderGisfoId: string;
  activityGisfoId: string;
  buildingUnitsGisfoId: string;
  idRisorsa: string;
  contractCode: string;
  metadata: { item: any; request: IGisfoCreateNetFaultMaintenance; response: IGisfoResponceNetFaultMaintenance };
  error: string;
}

export interface IID_ISSUE_LINK extends IBaseInterfaceData {
  linkToIssueId?: string;
  linkToIssueDataJson?: Partial<IIssue>;
}

export type IssueLinkWithDestInfo = IID_ISSUE_LINK & {
  destProjectId?: string;
  destStateId?: string;
};

export interface IID_ISSUE_LINKED extends IBaseInterfaceData {
  linkedByIssueId?: string;
  linkedByIssueDataJson?: Partial<IIssue>;
}

export enum Cause {
  "operatore" = "operatore",
  "olo" = "olo",
  "cliente" = "cliente"
}

export const causaOperatore = [
  {
    causale: "C10", //blocco tecnico provvisorio,
    causa: Cause.operatore,
    sbloccatoDa: CanUnlock.operatore
  },
  {
    causale: "C11", //blocco generico
    causa: Cause.operatore,
    sbloccatoDa: CanUnlock.operatore
  },
  {
    causale: "C12", // nuova gpon di attestazione
    causa: Cause.operatore,
    sbloccatoDa: CanUnlock.olo
  },
  {
    causale: "C13", //in attesa di realizzazione rfa
    causa: Cause.operatore,
    sbloccatoDa: CanUnlock.operatore
  },
  {
    causale: "C05",
    causa: Cause.operatore,
    sbloccatoDa: CanUnlock.operatore //modificato
  },
  {
    causale: "C09",
    causa: Cause.operatore,
    sbloccatoDa: CanUnlock.operatore //modificato
  }
];
export const causaCliente = [
  {
    causale: "D02", //cliente irreperibile on-call
    causa: Cause.cliente,
    sbloccatoDa: CanUnlock.olo
  },
  {
    causale: "D03", //cliente rifiuta l'intervento on call
    causa: Cause.cliente,
    sbloccatoDa: CanUnlock.olo
  },
  {
    causale: "D04", //rifiuto cliente on field
    causa: Cause.cliente,
    sbloccatoDa: CanUnlock.olo
  },
  {
    causale: "D05", //irreperibilità cliente onfield
    causa: Cause.cliente,
    sbloccatoDa: CanUnlock.olo
  },
  {
    causale: "D06", //cliente chiede di essere ricontattato per presa appuntamento
    causa: Cause.cliente,
    sbloccatoDa: CanUnlock.operatore
  },
  {
    causale: "D08", //cliente chiede un nuovo appuntamento per completamento intervento
    causa: Cause.cliente,
    sbloccatoDa: CanUnlock.operatore
  },
  {
    causale: "D09", //cliente in attesa di ulteriori chiarimenti commerciali
    causa: Cause.cliente,
    sbloccatoDa: CanUnlock.olo
  },
  {
    causale: "D10", //in attesa lavori in sede cliente
    causa: Cause.cliente,
    sbloccatoDa: CanUnlock.olo //cambiato
  },
  {
    causale: "D27", //infrastruttura cliente non idonea/ostruita
    causa: Cause.cliente,
    sbloccatoDa: CanUnlock.olo
  }
];
export const causaOlo = [
  {
    causale: "D07", //recapito cliente errato/inesistente
    causa: Cause.olo,
    sbloccatoDa: CanUnlock.olo
  },
  {
    causale: "D11", //ripianificazione appuntamento causa OLO
    causa: Cause.olo,
    sbloccatoDa: CanUnlock.olo
  },
  {
    causale: "B06", //id building esistente ma non quello per cui il cliente ha richiesto attivazione
    causa: Cause.olo,
    sbloccatoDa: CanUnlock.olo
  },
  {
    causale: "D25", //accettazione proposta tecnica prolungamento ottico
    causa: Cause.olo,
    sbloccatoDa: CanUnlock.olo
  },
  {
    causale: "D26", //accettazione proposta tecnica prolungamento ottico
    causa: Cause.olo,
    sbloccatoDa: CanUnlock.olo
  }
];

export type PortaleContratti_Contratto = { id: number; nomePortale: string; stato: StatoContrattoValue };
export type PortaleContratti_Articolo = { id: string; dataAttivazione?: string; dataDisattivazione?: string };

export interface IPortaleContratti extends IBaseInterfaceData {
  contratti: PortaleContratti_Contratto[];
  articoli: PortaleContratti_Articolo[];
}

export interface IID_OLOPOPSVLAN extends IBaseInterfaceData {
  svlan: string;
  cvlan: number;
  userVlan: string;
}


export const StatoAppuntamento = {
  DA_FARE: 0,
  ESEGUITO: 1,
  NON_ESEGUITO: 2
} as const;

export type StatoAppuntamentoKey = keyof typeof StatoAppuntamento;
export type StatoAppuntamentoValue = (typeof StatoAppuntamento)[StatoAppuntamentoKey];

export const StatoAppuntamentoEntries = Object.entries(StatoAppuntamento) as [StatoAppuntamentoKey, StatoAppuntamentoValue][];

/* Anagrafica Servizi Aggiuntivi*/
export interface IAnagraficaServizi extends IBaseEntity {
  nome: string;
  tipoServizio: string;
}
